import { Application } from "@hotwired/stimulus"
import { Autocomplete } from "stimulus-autocomplete"
import Appsignal from "@appsignal/javascript"
import { installErrorHandler } from "@appsignal/stimulus"

const application = Application.start()

// Report JS errors to AppSignal
// https://docs.appsignal.com/front-end/integrations/stimulus.html
var js_version = "1.0";

// Try to get the actual version from the <script> tag that has `application-<version>.js`
var scripts = document.getElementsByTagName('script');
for (var i = 0; i < scripts.length; i++) {
  var script = scripts[i];
  var match = script.src.match(/application-(.*)\.js/);
  if (match) {
    js_version = match[1];
  }
}

if (rails_env == 'production') {
  const appsignal = new Appsignal({
    // The key is found in AppSignal under: App Settings > Push & Deploy.
    key: "0e385ee6-c5c7-462b-a434-6db60df07d49",
    // The revision is needed in order for sourcemaps to work.
    // https://docs.appsignal.com/front-end/sourcemaps.html
    revision: js_version
  })

  window.appsignal = appsignal; // Make appsignal globally available

  installErrorHandler(appsignal, application);

  // Add a decorator so that errors reported from the frontend will have the path tag,
  // which helps us diagnose problems -- we'll know which page they occurred on.
  appsignal.addDecorator((span) => span.setTags({
    path: window.location.href, // We prefer .href over .pathname because it includes the query string
    user_id: user_id,
    user_is_internal: user_is_internal,
    user_is_external: user_is_external,
  }));
}

application.register("autocomplete", Autocomplete)

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
